import { render, staticRenderFns } from "./Relogin.vue?vue&type=template&id=53225bd0"
import script from "./Relogin.vue?vue&type=script&lang=js"
export * from "./Relogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports